<template>
  <baseEdit />
</template>

<script>
  import baseEdit from './baseEdit';

  export default {
    name: 'editRegister',
    components: {
      baseEdit,
    },
  };
</script>
